import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { REACTION_ORDER, REACTION_EMOJI } from "@/lib/i18nField";

export default function ReactionBar({ targetType, targetId, counts = {}, mine = [] }) {
  const { t } = useLang();
  const { user } = useAuth();
  const [c, setC] = useState(counts);
  const [my, setMy] = useState(new Set(mine));

  const react = async (emoji) => {
    if (!user) { toast.error(t("com_login_required")); return; }
    try {
      const { data } = await api.post("/community/react", { target_type: targetType, target_id: targetId, emoji });
      setC(data.reaction_counts);
      setMy((prev) => { const n = new Set(prev); data.active ? n.add(emoji) : n.delete(emoji); return n; });
    } catch { toast.error(t("com_error")); }
  };

  return (
    <div className="flex items-center gap-1.5" data-testid={`reactions-${targetId}`}>
      {REACTION_ORDER.map((emoji) => (
        <button key={emoji} data-testid={`react-${emoji}-${targetId}`} onClick={() => react(emoji)}
          className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs border transition-all ${my.has(emoji) ? "bg-amber-900/40 border-amber-600/60 text-amber-200" : "bg-[#181A20] border-[#272A34] text-stone-400 hover:border-amber-500/40"}`}>
          <span className="text-sm leading-none">{REACTION_EMOJI[emoji]}</span>
          {(c[emoji] || 0) > 0 && <span className="font-mono">{c[emoji]}</span>}
        </button>
      ))}
    </div>
  );
}
